import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Chip,
} from "@material-ui/core";

import { CHANGELOG } from "../../../data/changelog";
import { getLastWelcomeShownId, markWelcomeShown } from "../../../services/changelogSeenStorage";

const TIPO_LABEL = { new: "Nuevo", improvement: "Mejora", fix: "Corrección" };

function ultimaEntrada() {
  if (!CHANGELOG.length) return null;
  return [...CHANGELOG].sort((a, b) => b.date.localeCompare(a.date))[0];
}

// Se monta una sola vez a nivel de la app (ver App.js), así que "una vez
// por sesión" sale gratis: este componente no se vuelve a montar al
// navegar entre rutas. "Una vez por release" se resuelve comparando contra
// el id de la entrada más reciente guardado en localStorage — si sale una
// entrada con fecha más nueva, vuelve a mostrarse una vez más.
export default function ChangelogWelcomeModal() {
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const ultima = ultimaEntrada();

  const [open, setOpen] = useState(
    () => !!ultima && getLastWelcomeShownId() !== ultima.id
  );

  if (!atleteAccount || !ultima) return null;

  function cerrar() {
    markWelcomeShown(ultima.id);
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={cerrar} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Chip
          size="small"
          label={TIPO_LABEL[ultima.type] || ultima.type}
          color="primary"
          style={{ marginBottom: 8 }}
        />
        <Typography variant="h6">Novedades en el panel de Dashport</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          {ultima.title}
        </Typography>
        <Typography variant="body2">{ultima.summary}</Typography>
      </DialogContent>
      <DialogActions>
        <Button component={RouterLink} to="/novedades" onClick={cerrar}>
          Ver todas las novedades
        </Button>
        <Button onClick={cerrar} color="primary" variant="contained">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
